import React, { useState, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Navigate,
  useNavigate,
  useSearchParams
} from "react-router-dom";
import axios from "axios";
import Cookies from 'js-cookie';
import gsap from "gsap";
import classNames from "classnames";
import Config from "./Config.json";
import Package from '../package.json';
import speedTest from "./utils/speedtest";
import Login from './component/app.login';
import Canvas from './component/app.narrativeDetail';
import Narrative from './component/app.narrative';
import Gallery from './component/app.gallery';
import Narratives from './component/app.narratives';
import Documents from './component/app.documents';
import Reset from './component/app.reset';
import Learn from './component/app.learn';
import Account from './component/app.account';
import AccountPage from './component/app.accountPage';
import Library from './component/library';

import Timeline from './component/modules/timeline';
import Mapbox from './component/modules/mapbox';

import Help from './component/module.help';
import Modal from './component/module.modal';
import Loader from "./static/svg/loader.svg";
import LeftArrow from "./static/svg/leftarrow.svg";

// Icons
import {ReactComponent as Search} from "./static/icons/search.svg" 
import {ReactComponent as Home} from "./static/icons/home.svg" 
import {ReactComponent as Info} from "./static/icons/info.svg" 
import {ReactComponent as Logo} from "./static/svg/expo-logo.svg" 


import { startHeartbeat } from './utils/Heartbeat';
import './static/css/app.css';
// import logo from './logo.svg';

const routes = [
  // { path: '', name: 'BPS 3.0 Admin', Component: Narratives },
  { path: '/narratives/:id', name: '', Component: Canvas },
]

var base_url = Config.baseURL

function App() {
  // const helpHover = useRef();
  const [isUser, setIsUser] = useState(true);
  const [user, setUser] = useState(true);
  const [passToken, setPassToken] = useState(null);
  const [isDark, setIsDark] = useState(true);
  const [username, setUsername] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const [userId, setUserId] = useState(null);
  const [token, setToken] = useState(null);
  const [tools, setTools] = useState('search');
  const [showInfo, setShowInfo] = useState(false);
  const [hoverText, setHoverText] = useState(false);
  const [speed, setSpeed] = useState();
  const [formError, setFormError] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [speedClocked, setSpeedClocked] = useState(false);
  const [smLogo, setSmLogo] = useState(false);

  function handleShowSettings() {
    if (showSettings) {
      setShowSettings(false) 
    } else {
      setShowSettings(true) 
    }
  }


  function handleDarkMode() {
    let darkModeVal;
    if (isDark) {
      darkModeVal = false;
    } else {
      darkModeVal = true;
    }
    setIsDark(darkModeVal);
    setShowSettings(false);

    let formData = {};
    formData['id'] = userId;
    // formData['user'] = userId;
    formData['dark_mode'] = darkModeVal;

    try {
      // console.log('try prefs', userId, isDark)
      const url = base_url + "/api/user-setting/" + userId + '/';
      axios({
          method: "post",
          url: url,
          data: formData,
          headers: {
            Authorization: 'Token ' + token
          },
      }).then((response) => {
        console.log('response, isDark', response)
    
      });
    } catch (error) {
        console.error(error);
        console.log('error prefs', userId, isDark)
    }

  }

  function handleLogOut() {
    var cookie = Cookies.get('_expo_tokenid');
    if (cookie) {
      localStorage.removeItem('user');
      axios({
        method: 'post',
        baseURL: base_url,
        url: '/token/logout/',
        data: {
          'username': username,
          'token': cookie
        },
        headers: {
            Authorization: 'Token ' + cookie
        }

        })
        .then(response => {
          console.log('response', response, response.data['username'])
           function removeAllCookies() {
            const allCookies = Cookies.get(); // Get an object containing all cookies
    
            for (const cookieName in allCookies) {
                if (Object.hasOwnProperty.call(allCookies, cookieName)) {
                const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
                const cookieOptions = {
                    sameSite: 'Lax'
                };
                
                if (isLocalhost) {
                    // For localhost, don't set domain (defaults to current hostname)
                    cookieOptions.secure = false; // Allow HTTP for local dev
                } else {
                    // For production, use the expostudio.co domain
                    cookieOptions.domain = '.expostudio.co';
                    cookieOptions.secure = true; // Require HTTPS for production
                }
    
                Cookies.remove(cookieName, cookieOptions); 
                // If your cookies were set with specific path or domain, 
                // you need to provide those options to Cookies.remove()
                // e.g., Cookies.remove(cookieName, { path: '/', domain: '.yourdomain.com' });
                }
            }
            }
            removeAllCookies();
            localStorage.removeItem('user')
    

          setUsername(null);
          setIsUser(false);
          setToken(null);
          setPassToken(null);
        })
        .catch(function (error) {
          if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          } else if (error.request) {
          console.log(error.request);
          } else {
          console.log('Error', error.message);
          }
          console.log(error.config);
      });
    }
  }

  useEffect(() => {
    
    let cookie; 
    let c1 = Cookies.get('_expo_tokenid');
    let c2;
    let user = localStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
      if (user.token) {
        c2 = user.token;
        // Cookies.set('_expo_tokenid', user.token);
          // Set cookie domain based on environment
          const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
          const cookieOptions = {
              sameSite: 'Lax'
          };
          
          if (isLocalhost) {
              // For localhost, don't set domain (defaults to current hostname)
              cookieOptions.secure = false; // Allow HTTP for local dev
          } else {
              // For production, use the expostudio.co domain
              cookieOptions.domain = '.expostudio.co';
              cookieOptions.secure = true; // Require HTTPS for production
          }
          
          Cookies.set('_expo_tokenid', user.token, cookieOptions);
      }
    }
    if (c1) {
      cookie = c1;
    } else if (c2) {
      cookie = c2;
    }
    console.log('cookie', cookie)
    if (cookie) {      
      axios({
        method: 'get',
        baseURL: base_url,
        url: '/auth/users/me/',
        headers: {
            Authorization: 'Token ' + cookie
        }
        })
        .then(response => {
          console.log('response', response, response.data['username']);
          setShowLoader(true);
          !speedClocked && speedTest().then(speedInMbps => {
            setShowLoader(false);
            setSpeedClocked(true);
            // console.log('speedtest')
            if (speedInMbps < 60) {
              
              let newError = {
                "heading": "Warning",
                "text": "Your download speed was clocked at <strong>" + speedInMbps + "mb/s</strong>.<br/>This is slower than our recommended standard of 60mb/s. As a result you may experience issues when editing large presentations and files in this app."
              };
              setFormError(newError);
            }

          });

          if (response.data['username']) {
            setUsername(response.data['username']);
            setUserId(response.data['id']);
            setIsUser(true);
            setToken(cookie);
            setPassToken(cookie);
          } else {
            setUsername(null);
            setUserId(null);
            setIsUser(false);
          }
          if (response) {
            axios({
              method: 'get',
              baseURL: base_url,
              url: '/api/user-setting/' + response.data['id'],
              headers: {
                Authorization: 'Token ' + cookie
              },
              })
              .then(response => {
                console.log('user response', response.data)
                setUser(response.data);
              })
              .catch(function (error) {
                if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                } else if (error.request) {
                console.log(error.request);
                } else {
                console.log('Error', error.message);
                }
                console.log(error.config);
                setUser(null);
            });
          }
          
          
        })
        .catch(function (error) {
          if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          } else if (error.request) {
          console.log(error.request);
          } else {
          console.log('Error', error.message);
          }
          console.log(error.config);
          localStorage.removeItem('user');
          setUsername(null);
          setIsUser(false);
      });
    } else {
      localStorage.removeItem('user');
      setIsUser(false);
    }

    startHeartbeat();

  }, []);

  useEffect(() => {
    if (userId && token) {
      try {
        const url = base_url + "/api/user-setting/" + userId + "/";
        axios({
            method: "get",
            url: url,
            headers: {
              Authorization: 'Token ' + token
            },
        }).then((response) => {
          // console.log('user-settings', response, response.data['dark_mode'])
          setIsDark(response.data['dark_mode']);
        });
      } catch (error) {
          console.error(error);
          console.log('error prefs', userId, isDark)
      }
    }
  }, [userId, token])

  function onMouseEnter(e, text) {
    let target = document.getElementById("helpHover");
    setHoverText(text);
   
    function calcLeft(){
      let r = (e.target.getBoundingClientRect().x + e.target.getBoundingClientRect().width/2) - (text.length*8.5)/2; 
      if ((r + (text.length*9)) > window.innerWidth ) {
        r = window.innerWidth - (text.length*7)
      }
      return r
    }

    function calcTop(){
      let r = e.target.getBoundingClientRect().y - 45
      if ((r + 46) > window.innerHeight) {
        r = window.innerHeight - 46
      } else if ((r + 46) < 80) {
        r = e.target.getBoundingClientRect().y + e.target.getBoundingClientRect().height + 8
        document.querySelectorAll(".helpHoverCaret")[0].classList.add('reverse');
      } else {
        document.querySelectorAll(".helpHoverCaret")[0].classList.remove('reverse');
      }
      return r
    }
    gsap.to(target, {zIndex: 11, x: calcLeft(), y: calcTop(), duration: 0});
    gsap.to(target, {opacity: 1, duration: 0.3});
    
  }

  function onMouseLeave() {
    let target = document.getElementById("helpHover");
    setHoverText(null);
    gsap.to(target, {opacity: 0, duration: 0.3});
    gsap.to(target, {zIndex: -1, duration: 0});
   
  }


  return (

      <div className={classNames(
        "app",
        isDark ? "dark" : "light",
        smLogo && "smLogo"
      )}>

      {(showLoader)?(<div id="loading"><img src={Loader} alt="" /></div>):null}

      {(formError)&&<Modal heading={formError.heading} text={formError.text} onBtn1Click={setFormError} onBtn1={null} btn1Text={"Close"} onBtn2Click={null} onBtn2={null} btn2Text={null} />}

      {showInfo && <Modal heading={"Expo Studio"} text={"<span style='display: none;' class='betaText'>BETA</span><br/>Version: " + Package.version + "<br/>Build: " + Config.buildMajor + "." + Config.buildMinor + "." + Config.buildRevision} onBtn1Click={setShowInfo} onBtn1={false} btn1Text={"Ok"}  />}

      <Help text={hoverText} />

        {username && <header>
          <nav>
             <NavLink
              className={"menuLink"}
              to={"/"}
              // onClick={() => handlePageChange(route.path)}
             
            >
             <Logo className="logo" />
              
            </NavLink>
            
          </nav>

         

          <div id="showSettings">
                 <span href="" className="expo-pill-btn presentBtn" >Present</span>
         <div className="ui" onClick={()=>handleShowSettings()}>
            <span className="item username">{username && username.slice(0,1)}</span>
        
          </div>
      </div>
          {(showSettings) ? (
            <div className="userBtns">
              <span className="userBtn lower">
                <a href="/account">{username}</a>
              </span>
              <div style={{display: "none"}} className="userBtn mode ui" onClick={() => console.log('mode')}>{(isDark)?(
                <span className="iconField">
                <svg xmlns="http://www.w3.org/2000/svg" width="29.944" height="29.944" viewBox="0 0 29.944 29.944">
                <path id="Icon_feather-moon" data-name="Icon feather-moon" d="M31.5,19.185A13.5,13.5,0,1,1,16.815,4.5,10.5,10.5,0,0,0,31.5,19.185Z" transform="translate(-3.056 -3)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
              </svg>
              Dark Mode
                </span>
              ):(
                <svg id="Icon_feather-sun" data-name="Icon feather-sun" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                  <path id="Path_115" data-name="Path 115" d="M25.5,18A7.5,7.5,0,1,1,18,10.5,7.5,7.5,0,0,1,25.5,18Z" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                  <path id="Path_116" data-name="Path 116" d="M18,1.5v3" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                  <path id="Path_117" data-name="Path 117" d="M18,31.5v3" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                  <path id="Path_118" data-name="Path 118" d="M6.33,6.33,8.46,8.46" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                  <path id="Path_119" data-name="Path 119" d="M27.54,27.54l2.13,2.13" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                  <path id="Path_120" data-name="Path 120" d="M1.5,18h3" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                  <path id="Path_121" data-name="Path 121" d="M31.5,18h3" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                  <path id="Path_122" data-name="Path 122" d="M6.33,29.67l2.13-2.13" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                  <path id="Path_123" data-name="Path 123" d="M27.54,8.46l2.13-2.13" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                </svg>

              )}</div>
              {<div className="userBtn" onClick={() => handleLogOut()}>Log Out</div>}
              </div>
            ) : null}
           
        </header>}

        <Routes> 
          <Route index exact path="/" element={(isUser)?(<Narratives token={token} setSmLogo={setSmLogo} user={user} setTools={setTools} status={'active'} setShowInfo={setShowInfo} showInfo={showInfo} />):(<Navigate to="/login" />)} />
          <Route path="narratives">
            <Route index={true} element={(isUser)?(<Narratives token={token} setSmLogo={setSmLogo} user={user} setTools={setTools} status={'active'} onMouseEnter={onMouseEnter} setShowInfo={setShowInfo} showInfo={showInfo} />):(<Navigate to="/login" />)} />
            <Route path="deleted/" element={(isUser)?(<Narratives token={token} setSmLogo={setSmLogo} user={user} setTools={setTools} status={'deleted'} setShowInfo={setShowInfo} showInfo={showInfo} />):(<Navigate to="/login" />)} />
            <Route path=":id" element={(isUser)?(<Narrative token={token} setSmLogo={setSmLogo} user={user} setTools={setTools} onMouseEnter={onMouseEnter} />):(<Navigate to="/login" />)} />
            <Route path=":id/pages" element={(isUser)?(<Canvas token={token} setSmLogo={setSmLogo} user={user} setTools={setTools} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} />):(<Navigate to="/login" />)} />
          </Route>
          <Route path="modules">
            <Route path="gallery/:id" element={(isUser)?(<Gallery token={token} setSmLogo={setSmLogo} user={user} setTools={setTools} onMouseEnter={onMouseEnter}  onMouseLeave={onMouseLeave}/>):(<Navigate to="/login" />)} />
            <Route path="document/:id" element={(isUser)?(<Documents token={token} setSmLogo={setSmLogo} user={user} setTools={setTools} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}/>):(<Navigate to="/login" />)} />
            <Route path="mapbox/:id" element={(isUser)?(<Mapbox token={token} setSmLogo={setSmLogo} user={user} setTools={setTools} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}/>):(<Navigate to="/login" />)} />
            <Route path="timeline/:id" element={(isUser)?(<Timeline token={token} setSmLogo={setSmLogo} user={user} setTools={setTools} onMouseEnter={onMouseEnter}  onMouseLeave={onMouseLeave}/>):(<Navigate to="/login" />)} />
          </Route>
          <Route index exact path="/login" element={(isUser)?(<Navigate to="/" />):(<Login setUser={setUser} />)} />
          <Route index exact path="/reset-password" element={<Reset user={user} />} />
          <Route path="learn/" element={(isUser)?(<Learn user={user} setTools={setTools}/>):(<Navigate to="/login" />)} />
          <Route path="account/">
            <Route index={true} element={(isUser)?(<Account user={user} setTools={setTools} token={token} />):(<Navigate to="/login" />)} />
            <Route path=":slug/" element={(isUser)?(<AccountPage user={user} setTools={setTools} token={token} />):(<Navigate to="/login" />)} />
          </Route>

          <Route path="library/" element={(isUser)?(<Library isModal={false} setSmLogo={setSmLogo} user={user} setTools={setTools} status={'deleted'} setShowInfo={setShowInfo} showInfo={showInfo} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} />):(<Navigate to="/login" />)} />
        </Routes>

          
      </div>
    

    );

}

export default App;
// 
// {(tools === "search") && <div className="siteFilter ui searchField">
              
// <span>
//   <Search className="icon" />
//   <input type="text" className="search" placeholder="Search ..." />
// </span>
// </div>}

// <span className="aboutRow">
//             <a href="/" id="logo"><Logo className="logo" /></a>      
//             <span className="aboutRowCol">
//               <span className="beta" style={{display: "none"}}>BETA</span>
//               <span id="version" className="ui" onClick={() => setShowInfo(!showInfo)}>
//                   <span className="iconField"><Info className="iconMd fillWhite" /></span>
//               </span>
//             </span> 
            
//           </span>